import AppAPI, { DEFAULT_MESSAGES_PAGE_SIZE } from './api';

export default AppAPI;

export { DEFAULT_MESSAGES_PAGE_SIZE };
